"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getCurrentItem_1 = __importDefault(require("./getCurrentItem"));
var getListForItem_1 = __importDefault(require("./getListForItem"));
/**
 * Return the parent list block, from current selection or from a node (paragraph in a list item).
 */
var getCurrentList = function (opts) { return function (value, block) {
    var item = getCurrentItem_1.default(opts)(value, block);
    if (!item) {
        return null;
    }
    return getListForItem_1.default(opts)(value, item);
}; };
exports.default = getCurrentList;
//# sourceMappingURL=getCurrentList.js.map